import React from "react";
import PropTypes from "prop-types";
import organisationJsonLD from "./organisation.jsx";

class JsonLD extends React.Component {
  // eslint-disable-next-line max-params
  static createStructure(
    articleData,
    description,
    siteMetadata,
    featuredImage
  ) {

    /*
     * Article type example taken from:
     * https://search.google.com/structured-data/testing-tool
     *
     * Reference:
     * https://developers.google.com/search/docs/data-types/article#amp-sd
     */
    return {
      "@context": "http://schema.org",
      "@type": "Article",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": `${siteMetadata.siteUrl}${articleData.path}`
      },
      headline: articleData.title,
      image: `${siteMetadata.siteUrl}${featuredImage}`,
      datePublished: new Date(articleData.date).toISOString(),
      dateModified: new Date(articleData.date).toISOString(),
      author: {
        "@type": "Person",
        name: articleData.author
      },
      publisher: organisationJsonLD.createStructure(siteMetadata),
      description
    };
  }

  render() {
    const {
        articleData,
        description,
        siteMetadata,
        featuredImage
      } = this.props,
      structuredData = JsonLD.createStructure(
        articleData,
        description,
        siteMetadata,
        featuredImage
      );

    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    );
  }
}

JsonLD.propTypes = {
  description: PropTypes.string.isRequired,
  featuredImage: PropTypes.string.isRequired,
  articleData: PropTypes.shape({
    author: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }),
  siteMetadata: PropTypes.shape({
    siteUrl: PropTypes.string.isRequired,
    social: PropTypes.shape({
      twitter: PropTypes.string.isRequired,
      linkedin: PropTypes.string.isRequired,
      github: PropTypes.string.isRequired
    }),
    title: PropTypes.string.isRequired
  })
};

export default JsonLD;



// WEBPACK FOOTER //
// ./src/components/JsonLD/article.jsx